import { PriceBasisEnum } from '../../enums/BookingFunnelEnum';

export interface GetExcursionsMyMSCResponse {
  excursions: MyMscExcursion[];
}

export enum difficultyLevel {
  EASY = 'EASY',
  MEDIUM = 'MEDIUM',
  HARD = 'HARD',
}

export interface MyMscExcursion {
  id?: number;
  code: string;
  price: string;
  locationCode?: string;
  name?: string;
  description: string;
  longDescription: string;
  startDate: string;
  endDate: string;
  paymentType: string;
  duration: number;
  currencyCode: string;
  images: Images;
  priceBasis: PriceBasisEnum;
  isPackage: boolean;
  packageDetails: PackageDetails[];
  portCode?: string;
  activityDetails?: ActivityDetails;
  guideLanguageCodes?: string[];
  activityGroup?: ActivityGroup;
  prices: Prices;
  inventory?: Inventory;
  promotion?: Promotion;
  videoId?: string;
  video: string;
  videoDescription: string;
  assets: Array<{
    excursion: {
      image: string;
      optimisedImage: string;
    };
    alternativeText: string;
  }>;
  day?: number;
  portName?: string;
  index?: number;
}

export interface PackageDetails {
  code: string;
  portCode: string;
  description?: string;
  longDescription?: string;
  duration?: number;
  images: Images;
  activityDetails: ActivityDetails;
  activityGroup?: ActivityGroup;
  guideLanguageCodes: string[];
  isGuideAvailable: boolean;
  isBestSeller: boolean;
  isWheelchairFriendly: boolean;
  isSnackIncluded: boolean;
  isMealIncluded: boolean;
  isBusTransportAvailable: boolean;
  isDrinkIncluded: boolean;
  isSwimmingIncluded: boolean;
  isTastingIncluded: boolean;
  isFilmingAllowed: boolean;
  isShoppingIncluded: boolean;
  difficultyLevel: string;
}

interface Images {
  image: string;
  desktop?: {
    image: string;
    optimisedImage: string;
  };
  mobile?: {
    image: string;
    optimisedImage: string;
  };
}

interface ActivityDetails {
  isBestSeller: boolean;
  isBusTransportAvailable: boolean;
  isInvolvesWalking: boolean;
  isCulturalActivity: boolean;
  isDrinkIncluded: boolean;
  isFamilyFriendlyActivity: boolean;
  isMealIncluded: boolean;
  difficultyLevel: string;
  isFilmingAllowed: boolean;
  isGuideAvailable: boolean;
  guideLanguageCodes: string[];
  isShoppingIncluded: boolean;
  isSnackIncluded: boolean;
  isSwimmingIncluded: boolean;
  isTastingIncluded: boolean;
  isTourActivity: boolean;
  isWalkingDifficulty: boolean;
  isWheelchairFriendly: boolean;
  minimumPassengersRequired?: number;
  isLimitedSeats: boolean;
  isBestRated: boolean;
  notes?: string;
}

interface ActivityGroup {
  details?: string;
  description?: string;
}

export interface Prices {
  perAdult?: Price;
  perJunior?: Price;
  perChild?: Price;
  perInfant?: Price;
  perSenior?: Price;
  perCabin?: Price;
}

interface Price {
  total: Total;
  discountPercentage?: string;
  tax: string;
}

interface Total {
  afterDiscount: string;
  beforeDiscount?: string;
}

interface Inventory {
  numberAvailable: string;
  type: string;
}

interface Promotion {
  id: string;
  type: string;
  description: string;
  webDescription: string;
  validFrom: string;
  validTo: string;
}
